import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const techGearAdvisorsStylesUS: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white tablet:bg-[#F4F4F5]',

  COMMONS_APPBAR_BG: 'bg-[#39D39F]',
  COMMONS_APPBAR_TEXT: 'text-white',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',

  COMMONS_FOOTER_BG: 'bg-[#39D39F]',
  COMMONS_FOOTER_TEXT: 'text-white',

  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#39D39F] [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: 'shadow-xl',

  HOMEPAGE_HEADER_BG: 'bg-[#F4F6FA]',
  HOMEPAGE_HEADER_TEXT: 'text-black',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#39D39F]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#29BC8B]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-black',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-black',

  HOMEPAGE_TOPRATED_BUTTON: 'border-[#29BC8B] hover:border-[#29BC8B] hover:bg-[#29BC8B] hover:text-white text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#29BC8B]',

  HOMEPAGE_RANK_BANNER_BG: 'bg-[#39D39F]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#39D39F]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#29BC8B]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#7F89DB] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#39D39F] text-[#39D39F] [&>svg>path]:stroke-[#39D39F] [&>svg>g>path]:stroke-[#39D39F] [&>svg>path]:fill-[#39D39F] [&>svg>g>path]:fill-[#39D39F]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#7F89DB]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#39D39F]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#F4F6FA]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#29BC8B]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#F4F6FA]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#39D39F] [&>.explore-icon-fill]:!fill-[#F4F6FA] [&>g>.explore-icon-fill]:!fill-[#F4F6FA]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#F4F6FA] [&>.vector-top>path]:fill-[#39D39F] [&>.vector-bottom>path]:fill-[#39D39F]',

  LISTPAGE_USER_VALUE_BADGE: 'text-[#39D39F] [&>div>svg>path]:fill-[#39D39F] bg-[#F4F6FA]',

  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#29BC8B]',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-white',

  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#39D39F]',

  LISTPAGE_BADGE_WINNER_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#39D39F]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#39D39F]',

  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-[#39D39F]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#39D39F]',

  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#29BC8B]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',

  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-[#39D39F]',

  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-black',

  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#39D39F]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#39D39F]',

  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-black',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:!fill-black',

  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#39D39F]',

  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#7F89DB] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#39D39F] text-[#39D39F] [&>svg>path]:stroke-[#39D39F] [&>svg>g>path]:stroke-[#39D39F] [&>svg>path]:fill-[#39D39F] [&>svg>g>path]:fill-[#39D39F]',
  LISTPAGE_BUTTON_LINK: 'text-[#7F89DB]',
  LISTPAGE_ANCHOR_LINK: 'text-[#7F89DB]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#7F89DB]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#7F89DB]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#7F89DB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#7F89DB] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#39D39F] text-[#39D39F]  [&>svg>path]:stroke-[#39D39F] [&>svg>g>path]:stroke-[#39D39F] [&>svg>path]:fill-[#39D39F] [&>svg>g>path]:fill-[#39D39F]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#7F89DB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#7F89DB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#7F89DB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#7F89DB]',

  LISTPAGE_SPONSORED_CARD_BORDER: 'border-[#7F89DB]',

  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border-none',

  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#7F89DB]',

  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#F4F6FA] [&>.vector-top>path]:fill-[#39D39F] [&>.vector-bottom>path]:fill-[#39D39F]',

  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-neutral-100 tablet:bg-[#E2E8F0]',

  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#F4F6FA] [&>circle]:stroke-[#F4F6FA] [&>path]:fill-[#39D39F]',

  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#F4F6FA]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-[#7F89DB]',

  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5] tablet:bg-white',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:text-black data-[focus]:bg-[#F4F6FA]',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'text-[#7F89DB] bg-[#F4F6FA]',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#7F89DB]',

  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5] tablet:bg-white',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5] tablet:bg-white',

  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5] tablet:bg-white',

  UTILS_MAIN_CONTAINER: 'content-container-new-layout',
}
